import styled from "styled-components";
import { css } from "@emotion/core";

export const Jumbotron = styled.div`
  width: 100%;
  height: auto;
  padding-bottom: 100px;
  position: relative;

  @media (max-width: 529px) {
    padding-bottom: 80px;
  }
`;
export const JumbotronContainer = styled.div`
  width: 50%;
  height: auto;
  margin: 0 auto;
  padding-top: 154px;
  position: relative;

  @media (max-width: 529px) {
    width: 80%;
    text-align: center;
    padding-bottom: 0;
    padding-top: 80px;
  }
`;
export const Overview = styled.p`
  font-family: Gotham;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 29px;
  text-align: center;
  color: #5a6163;
  margin-bottom: 73px;
`;

export const SearchResultPage = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  position: relative;

  @media (max-width: 529px) {
    width: 100% !important;
  }
`;

export const override = css`
  margin: 0 50%;
`;

export const ModalContainer = styled.div`
  width: 100%;
`;

export const AccountCreated = styled.p`
  margin-top: 10px;
  font-family: Gotham;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 29px;
  color: #0d0e1e;
`;
export const VerifyP = styled.p`
  font-size: 20px;
  color: #637381;
  margin-top: 60px;

  @media (max-width: 529px) {
    font-size: 13px;
    text-align: center;
  }
`;
export const ResendVerificationButton = styled.button`
  height: 45px;
  background: #7e32ca;
  box-shadow: 0px 2px 6px rgba(196, 196, 196, 0.3);
  border-radius: 4px;
  border: none;
  outline: none;
  font-family: Gotham;
  font-weight: bold;
  font-size: 16px;
  line-height: 143.16%;
  color: #fefefe;
  padding: 5px 8px;
  margin-top: 60px;
  margin-bottom: 60px;
`;
